import { render, staticRenderFns } from "./ProductsContent.vue?vue&type=template&id=f6f81bc0&"
import script from "./ProductsContent.vue?vue&type=script&lang=ts&"
export * from "./ProductsContent.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsContent.vue?vue&type=style&index=0&id=f6f81bc0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports